import * as React from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import SEO from '../components/SEO/SEO';
import Sidebar from '../components/Sidebar/Sidebar';
import { useState } from 'react';

interface LayoutProps {
	children: any;
	title: string;
	menuItems: Array<{ text: string; href: string; active: boolean }>;
	desc: string;
}

const Layout: React.FC<LayoutProps> = (props: LayoutProps) => {
	const [sidebarOpened, setSidebarOpened] = useState(false);
	const openSidebarHandler = () => {
		setSidebarOpened(!sidebarOpened);
	};
	return (
		<>
			<SEO title={props.title} desc={props.desc} />
			<Header
				menuItems={props.menuItems}
				sidebarHandler={openSidebarHandler}
			/>
			<main>
				<Sidebar
					menuItems={props.menuItems}
					sidebarHandler={openSidebarHandler}
					open={sidebarOpened}
				>
					{props.children}
				</Sidebar>
			</main>
			<Footer />
		</>
	);
};

export default Layout;
